import React from "react";
import "./Description.css";
import {useLanguage} from "../context/LanguageContext";
const Description = () => {
    const { language, setLanguage } = useLanguage();

    return (
        <div className="description">
            {language === 'en' ? (<h4 className="head">About</h4>): (<h4 className="head_ar">نبذة عامة</h4>)}

            {language === 'en' ? (<p>A Multi-device platform that brings consumers the world’s best independent movie titles across different Genres</p>):
                (<p className="p_ar" >يحتوي BestIndie على أكثر من 1000 فيلم وثائقي وإثارة وكوميديا وأفلام بلغة أجنبية والمزيد</p>)}
        </div>
    );
};

export default Description;

//      A Multi-device platform that brings consumers the world’s best independent movie titles across different Genres